export default __webpack_public_path__ + "static/media/X_close.703aa323.svg";